<template>
  <div
    class="chat-module"
    style="height: 100%;"
  >
    <header class="chat-module__header">
      <div class="chat-module__title">
        <svg class="chat-module__icon">
          <use
            width="14"
            height="14"
            href="/img/icons/sparkles.svg#icon-sparkles"
          />
        </svg>
        <span class="chat-module__label">Optix AI</span>
      </div>
      <button
        class="chat-module__clear-btn"
        @click="onClearChat"
      >
        Clear
      </button>
    </header>
    <div class="chat-module__separator" />
    <div class="chat-module__body">
      <AIEditorTab
        ref="editor"
        :target-element="targetElement"
      />
    </div>
  </div>
</template>

<script>
import AIEditorTab from "./AIEditorTab.vue";

export default {
  name: "AIChatModule",
  components: {
    AIEditorTab,
  },
  props: {
    targetElement: {
      type: fabric.Object,
      require: true,
      default: () => {
      },
    },
  },
  data: () => ({
    selectedTab: "ai-editor",
  }),
  methods: {
    onClearChat() {
      this.$refs.editor.clearChat();
    }
  }
};
</script>

<style lang="scss" scoped>
.chat-module {
  display: flex;
  flex-direction: column;

  &__separator {
    height: 1px;
    background-color: #e9ecef;
    margin: 8px 0;
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__title {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  &__icon {
    width: 14px;
    height: 14px;
    color: #379C75;
  }

  &__label {
    font-weight: bold;
  }
  
  &__clear-btn {
    background-color: transparent;
    border: none;
    color: #9FA3A9;
    font-weight: bold;
    
    &:hover {
      color: #379C75;
    }
  }

  &__body {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    min-height: 0;
    overflow: hidden;
  }
}
</style>
